<style>
  .all {
    /* TODO: MODAA KUN https://github.com/angular/material2/issues/8493 on korjattu */
    max-height: 95vh;
  }
</style>
<div class="all teksti" mat-dialog-content>
  <lemon-dialog-header [naytaSuljeRuksi]="false" [naytaOtsikko]="false"></lemon-dialog-header>
  <div class="light-blue-text otsikko">
    {{ 'lemonaid-sopimus-dialog.kyc.yhtion-tunteminen' | translate | async }}
  </div>

  <div class="kyc-content">
    <div class="dynamic-spacer"></div>
    <div class="dynamic-spacer"></div>

    <div [innerHtml]="'lemonaid-sopimus-dialog.rahanpesulaki-velvoittaa-keramaan' | translate | async"></div>
    <div class="dynamic-spacer"></div>

    <div [innerHtml]="'lemonaid-sopimus-dialog.yhtiosi-tuntemistiedot' | translate | async"></div>

    <form #tunnistamisForm="ngForm" style="text-align: left">
      <div class="kyc-otsikko">{{ 'lemonaid-sopimus-dialog.kyc.osakkaat' | translate | async }}</div>
      <div>{{ 'lemonaid-sopimus-dialog.kyc.anna-osakkeiden-tiedot' | translate | async }}</div>

      @if (onkoVirhe(osakasRivit, 'min')) {
        <div class="lemon-error">{{ 'lemonaid-sopimus-dialog.kyc.vahintaan-yksi-osakas' | translate | async }}</div>
      }
      <div>
        @for (osakasRivi of osakasRivit; track osakasRivi; let i = $index) {
          <div class="kyc-item">
            <div class="kyc-checkbox">
              <mat-checkbox [labelPosition]="'before'" [formField]="osakasRivi.noFinnishId">{{ 'lemonaid-sopimus-dialog.kyc.ei-suomalaista-tunnusta' | translate | async }} </mat-checkbox>
            </div>
            <mat-radio-group class="kyc-radio" [formField]="osakasRivi.onkoYritys" [style.display]="osakasRivi.onkoYritys().disabled() ? 'none' : 'flex'">
              <mat-radio-button style="margin: 5px" [value]="false">{{ 'lemonaid-sopimus-dialog.kyc.osakas-on-luonnollinen' | translate | async }}</mat-radio-button>
              <mat-radio-button style="margin: 5px" [value]="true">{{ 'lemonaid-sopimus-dialog.kyc.osakas-on-yritys' | translate | async }}</mat-radio-button>
            </mat-radio-group>
            <div class="kyc-single-row">
              <mat-form-field class="right-margin-in-large-view">
                <mat-label>{{ 'lemonaid-sopimus-dialog.kyc.nimi' | translate | async }}</mat-label>
                <input type="text" [formField]="osakasRivi.nimi" autocomplete="nothing" matInput data-lpignore="true" />
                <mat-error>
                  @if (osakasRivi.nimi; as n) {
                    @if (n().touched() || tunnistamisForm.submitted) {
                      @if (onkoVirhe(n, 'required')) {
                        {{ 'lemonaid-sopimus-dialog.kyc.nimi-required' | translate | async }}
                      }
                    }
                  }
                </mat-error>
              </mat-form-field>
              <mat-form-field class="right-margin-in-large-view">
                <mat-label>{{ 'lemonaid-sopimus-dialog.kyc.hetu-ytunnus' | translate | async }}</mat-label>
                <input type="text" [formField]="osakasRivi.hetu" autocomplete="nothing" matInput data-lpignore="true" />
                <mat-error>
                  @if (osakasRivi.hetu; as n) {
                    @if (n().touched() || tunnistamisForm.submitted) {
                      @if (onkoVirhe(n, 'required')) {
                        {{ 'lemonaid-sopimus-dialog.kyc.hetu-ytunnus-required' | translate | async }}
                      }
                      @if (onkoVirhe(n, 'invalid')) {
                        {{ 'lemonaid-sopimus-dialog.kyc.hetu-ytunnus-invalid' | translate | async }}
                      }
                      @if (onkoVirhe(n, 'ownytunnus')) {
                        {{ 'lemonaid-sopimus-dialog.kyc.oma-ytunnus' | translate | async }}
                      }
                    }
                  }
                </mat-error>
              </mat-form-field>
              <!-- <div class="right-margin-in-large-view" style="align-self: center;" [style.display]="!osakasFormGroup.get('noFinnishId').value ? 'none': 'inline-block'">
              <mat-checkbox formControlName="onkoYritys">{{'lemonaid-sopimus-dialog.kyc.yritys' | translate | async }}
              </mat-checkbox>
            </div> -->
              <mat-form-field class="right-margin-in-large-view" [style.display]="osakasRivi.birthDate().disabled() ? 'none' : 'inline-block'">
                <mat-label>{{ 'lemonaid-sopimus-dialog.kyc.syntymaaika' | translate | async }}</mat-label>
                <input type="text" [matDatepicker]="picker1" [formField]="osakasRivi.birthDate" autocomplete="nothing" matInput data-lpignore="true" />
                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                <mat-error>
                  @if (osakasRivi.birthDate; as n) {
                    @if (n().touched() || tunnistamisForm.submitted) {
                      @if (onkoVirhe(n, 'required')) {
                        {{ 'lemonaid-sopimus-dialog.kyc.syntymaaika-required' | translate | async }}
                      }
                    }
                  }
                </mat-error>
              </mat-form-field>
              <mat-datepicker #picker1></mat-datepicker>
              <mat-form-field>
                <mat-label>{{ 'lemonaid-sopimus-dialog.kyc.osakkeiden-lukumaara' | translate | async }}</mat-label>
                <input decimalNumberField matInput [formField]="osakasRivi.osakkeita" [numberOfDecimals]="0" autocomplete="nothing" data-lpignore="true" />
                <mat-error>
                  @if (osakasRivi.osakkeita; as n) {
                    @if (n().touched() || tunnistamisForm.submitted) {
                      @if (onkoVirhe(n, 'required')) {
                        {{ 'lemonaid-sopimus-dialog.kyc.osakkeiden-lukumaara-puuttuu' | translate | async }}
                      }
                    }
                  }
                </mat-error>
              </mat-form-field>
            </div>
            <div class="kyc-single-row">
              <mat-form-field class="right-margin-in-large-view">
                <mat-label>{{ 'lemonaid-sopimus-dialog.kyc.kansallisuus' | translate | async }}</mat-label>
                <mat-select [formField]="osakasRivi.kansallisuus">
                  @for (kansa of kansallisuudetObservable | async; track kansa) {
                    <mat-option [value]="kansa.koodi">
                      {{ kansa.nimi }}
                    </mat-option>
                  }
                </mat-select>
                <mat-error>
                  @if (osakasRivi.kansallisuus; as n) {
                    @if (n().touched() || tunnistamisForm.submitted) {
                      @if (onkoVirhe(n, 'required')) {
                        {{ 'lemonaid-sopimus-dialog.kyc.kansallisuus-required' | translate | async }}
                      }
                    }
                  }
                </mat-error>
              </mat-form-field>
              <mat-form-field>
                <mat-label>{{ ('lemonaid-sopimus-dialog.kyc.pep' | translate | async) + ' (PEP)' }}</mat-label>
                <mat-select [formField]="osakasRivi.pep">
                  <mat-option [value]="true">
                    {{ 'lemonaid-sopimus-dialog.kyc.kylla' | translate | async }}
                  </mat-option>
                  <mat-option [value]="false">
                    {{ 'lemonaid-sopimus-dialog.kyc.ei' | translate | async }}
                  </mat-option>
                </mat-select>
                <mat-error>
                  @if (osakasRivi.pep; as n) {
                    @if (n().touched() || tunnistamisForm.submitted) {
                      @if (onkoVirhe(n, 'required')) {
                        {{ 'lemonaid-sopimus-dialog.kyc.pep-required' | translate | async }}
                      }
                    }
                  }
                </mat-error>
              </mat-form-field>
            </div>
            <div (click)="openPepText()" class="form-comment">{{ 'lemonaid-sopimus-dialog.kyc.kuka-on-pep' | translate | async }}</div>
            <button mat-icon-button (click)="poistaOsakas(i); $event.preventDefault()">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        }
        <button class="primarybutton kyc-lisaa" mat-button (click)="lisaaOsakas(); $event.preventDefault()">
          <!-- {{'yleiset.jatka' | translate | async }} -->
          {{ 'lemonaid-sopimus-dialog.kyc.lisaa-osakas' | translate | async }}
        </button>
      </div>

      <div class="kyc-otsikko">{{ 'lemonaid-sopimus-dialog.kyc.hallitus-ja-toimitusjohtaja' | translate | async }}</div>
      <div>{{ 'lemonaid-sopimus-dialog.kyc.anna-paattajien-tiedot' | translate | async }}</div>

      @if (onkoVirhe(hallitusRivit, 'min')) {
        <div class="lemon-error">{{ 'lemonaid-sopimus-dialog.kyc.vahintaan-yksi-hallituksen-jasenen' | translate | async }}</div>
      }

      <div>
        @for (jasenRivi of hallitusRivit; track jasenRivi; let i = $index) {
          <div class="kyc-item">
            <div class="kyc-checkbox">
              <mat-checkbox [labelPosition]="'before'" [formField]="jasenRivi.noFinnishId">{{ 'lemonaid-sopimus-dialog.kyc.ei-suomalaista-tunnusta' | translate | async }} </mat-checkbox>
            </div>
            <div class="kyc-single-row">
              <mat-form-field class="right-margin-in-large-view">
                <mat-label>{{ 'lemonaid-sopimus-dialog.kyc.nimi' | translate | async }}</mat-label>
                <input type="text" [formField]="jasenRivi.nimi" autocomplete="nothing" matInput data-lpignore="true" />
                <mat-error>
                  @if (jasenRivi.nimi; as n) {
                    @if (n().touched() || tunnistamisForm.submitted) {
                      @if (onkoVirhe(n, 'required')) {
                        {{ 'lemonaid-sopimus-dialog.kyc.nimi-required' | translate | async }}
                      }
                    }
                  }
                </mat-error>
              </mat-form-field>
              <mat-form-field class="right-margin-in-large-view">
                <mat-label>{{ 'lemonaid-sopimus-dialog.kyc.hetu' | translate | async }}</mat-label>
                <input type="text" [formField]="jasenRivi.hetu" autocomplete="nothing" matInput data-lpignore="true" />
                <mat-error>
                  @if (jasenRivi.hetu; as n) {
                    @if (n().touched() || tunnistamisForm.submitted) {
                      @if (onkoVirhe(n, 'required')) {
                        {{ 'lemonaid-sopimus-dialog.kyc.hetu-required' | translate | async }}
                      }
                      @if (onkoVirhe(n, 'invalid')) {
                        {{ 'lemonaid-sopimus-dialog.kyc.hetu-invalid' | translate | async }}
                      }
                    }
                  }
                </mat-error>
              </mat-form-field>
              <mat-form-field class="right-margin-in-large-view" [style.display]="jasenRivi.birthDate().disabled() ? 'none' : 'inline-block'">
                <mat-label>{{ 'lemonaid-sopimus-dialog.kyc.syntymaaika' | translate | async }}</mat-label>
                <input type="text" [matDatepicker]="picker2" [formField]="jasenRivi.birthDate" autocomplete="nothing" matInput data-lpignore="true" />
                <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                <mat-error>
                  @if (jasenRivi.birthDate; as n) {
                    @if (n().touched() || tunnistamisForm.submitted) {
                      @if (onkoVirhe(n, 'required')) {
                        {{ 'lemonaid-sopimus-dialog.kyc.syntymaaika-required' | translate | async }}
                      }
                    }
                  }
                </mat-error>
              </mat-form-field>
              <mat-datepicker #picker2></mat-datepicker>
              <mat-form-field>
                <mat-label>{{ 'lemonaid-sopimus-dialog.kyc.rooli' | translate | async }}</mat-label>
                <mat-select [formField]="jasenRivi.rooli">
                  @for (rooli of hallitusRoolitObservable | async; track rooli) {
                    <mat-option [value]="rooli.avain">
                      {{ rooli.nimi }}
                    </mat-option>
                  }
                </mat-select>
                <mat-error>
                  @if (jasenRivi.rooli; as n) {
                    @if (n().touched() || tunnistamisForm.submitted) {
                      @if (onkoVirhe(n, 'required')) {
                        {{ 'lemonaid-sopimus-dialog.kyc.rooli-required' | translate | async }}
                      }
                    }
                  }
                </mat-error>
              </mat-form-field>
            </div>
            <div class="kyc-single-row">
              <mat-form-field class="right-margin-in-large-view">
                <mat-label>{{ 'lemonaid-sopimus-dialog.kyc.kansallisuus' | translate | async }}</mat-label>
                <mat-select [formField]="jasenRivi.kansallisuus">
                  @for (kansa of kansallisuudetObservable | async; track kansa) {
                    <mat-option [value]="kansa.koodi">
                      {{ kansa.nimi }}
                    </mat-option>
                  }
                </mat-select>
                <mat-error>
                  @if (jasenRivi.kansallisuus; as n) {
                    @if (n().touched() || tunnistamisForm.submitted) {
                      @if (onkoVirhe(n, 'required')) {
                        {{ 'lemonaid-sopimus-dialog.kyc.kansallisuus-required' | translate | async }}
                      }
                    }
                  }
                </mat-error>
              </mat-form-field>
              <mat-form-field>
                <mat-label>{{ ('lemonaid-sopimus-dialog.kyc.pep' | translate | async) + ' (PEP)' }}</mat-label>
                <mat-select [formField]="jasenRivi.pep">
                  <mat-option [value]="true">
                    {{ 'lemonaid-sopimus-dialog.kyc.kylla' | translate | async }}
                  </mat-option>
                  <mat-option [value]="false">
                    {{ 'lemonaid-sopimus-dialog.kyc.ei' | translate | async }}
                  </mat-option>
                </mat-select>
                <mat-error>
                  @if (jasenRivi.pep; as n) {
                    @if (n().touched() || tunnistamisForm.submitted) {
                      @if (onkoVirhe(n, 'required')) {
                        {{ 'lemonaid-sopimus-dialog.kyc.pep-required' | translate | async }}
                      }
                    }
                  }
                </mat-error>
              </mat-form-field>
            </div>
            <div (click)="openPepText()" class="form-comment">{{ 'lemonaid-sopimus-dialog.kyc.kuka-on-pep' | translate | async }}</div>
            <button mat-icon-button (click)="poistaHallituksenJasen(i); $event.preventDefault()">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        }
        <button class="primarybutton kyc-lisaa" mat-button (click)="lisaaHallituksenJasen(); $event.preventDefault()">
          <!-- {{'yleiset.jatka' | translate | async }} -->
          {{ 'lemonaid-sopimus-dialog.kyc.lisaa-jasen' | translate | async }}
        </button>
      </div>

      <div class="kyc-otsikko">{{ 'lemonaid-sopimus-dialog.kyc.edunsaajat' | translate | async }}</div>
      <div>{{ 'lemonaid-sopimus-dialog.kyc.edunsaajien-tiedot' | translate | async }}</div>

      <div>
        @for (saajaRivi of edunsaajaRivit; track saajaRivi; let i = $index) {
          <div class="kyc-item">
            <div class="kyc-checkbox">
              <mat-checkbox [labelPosition]="'before'" [formField]="saajaRivi.noFinnishId">{{ 'lemonaid-sopimus-dialog.kyc.ei-suomalaista-tunnusta' | translate | async }} </mat-checkbox>
            </div>
            <div class="kyc-single-row">
              <mat-form-field class="right-margin-in-large-view">
                <mat-label>{{ 'lemonaid-sopimus-dialog.kyc.nimi' | translate | async }}</mat-label>
                <input type="text" [formField]="saajaRivi.nimi" autocomplete="nothing" matInput data-lpignore="true" />
                <mat-error>
                  @if (saajaRivi.nimi; as n) {
                    @if (n().touched() || tunnistamisForm.submitted) {
                      @if (onkoVirhe(n, 'required')) {
                        {{ 'lemonaid-sopimus-dialog.kyc.nimi-required' | translate | async }}
                      }
                    }
                  }
                </mat-error>
              </mat-form-field>
              <mat-form-field>
                <mat-label>{{ 'lemonaid-sopimus-dialog.kyc.hetu' | translate | async }}</mat-label>
                <input type="text" [formField]="saajaRivi.hetu" autocomplete="nothing" matInput data-lpignore="true" />
                <mat-error>
                  @if (saajaRivi.hetu; as n) {
                    @if (n().touched() || tunnistamisForm.submitted) {
                      @if (onkoVirhe(n, 'required')) {
                        {{ 'lemonaid-sopimus-dialog.kyc.hetu-required' | translate | async }}
                      }
                      @if (onkoVirhe(n, 'invalid')) {
                        {{ 'lemonaid-sopimus-dialog.kyc.hetu-invalid' | translate | async }}
                      }
                    }
                  }
                </mat-error>
              </mat-form-field>
              <mat-form-field class="left-margin-in-large-view" [style.display]="saajaRivi.birthDate().disabled() ? 'none' : 'inline-block'">
                <mat-label>{{ 'lemonaid-sopimus-dialog.kyc.syntymaaika' | translate | async }}</mat-label>
                <input type="text" [matDatepicker]="picker3" [formField]="saajaRivi.birthDate" autocomplete="nothing" matInput data-lpignore="true" />
                <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
                <mat-error>
                  @if (saajaRivi.birthDate; as n) {
                    @if (n().touched() || tunnistamisForm.submitted) {
                      @if (onkoVirhe(n, 'required')) {
                        {{ 'lemonaid-sopimus-dialog.kyc.syntymaaika-required' | translate | async }}
                      }
                    }
                  }
                </mat-error>
              </mat-form-field>
              <mat-datepicker #picker3></mat-datepicker>
            </div>
            <div class="kyc-single-row">
              <mat-form-field class="right-margin-in-large-view">
                <mat-label>{{ 'lemonaid-sopimus-dialog.kyc.kansallisuus' | translate | async }}</mat-label>
                <mat-select [formField]="saajaRivi.kansallisuus">
                  @for (kansa of kansallisuudetObservable | async; track kansa) {
                    <mat-option [value]="kansa.koodi">
                      {{ kansa.nimi }}
                    </mat-option>
                  }
                </mat-select>
                <mat-error>
                  @if (saajaRivi.kansallisuus; as n) {
                    @if (n().touched() || tunnistamisForm.submitted) {
                      @if (onkoVirhe(n, 'required')) {
                        {{ 'lemonaid-sopimus-dialog.kyc.kansallisuus-required' | translate | async }}
                      }
                    }
                  }
                </mat-error>
              </mat-form-field>
              <mat-form-field>
                <mat-label>{{ ('lemonaid-sopimus-dialog.kyc.pep' | translate | async) + ' (PEP)' }}</mat-label>
                <mat-select [formField]="saajaRivi.pep">
                  <mat-option [value]="true">
                    {{ 'lemonaid-sopimus-dialog.kyc.kylla' | translate | async }}
                  </mat-option>
                  <mat-option [value]="false">
                    {{ 'lemonaid-sopimus-dialog.kyc.ei' | translate | async }}
                  </mat-option>
                </mat-select>
                <mat-error>
                  @if (saajaRivi.pep; as n) {
                    @if (n().touched() || tunnistamisForm.submitted) {
                      @if (onkoVirhe(n, 'required')) {
                        {{ 'lemonaid-sopimus-dialog.kyc.pep-required' | translate | async }}
                      }
                    }
                  }
                </mat-error>
              </mat-form-field>
            </div>
            <div (click)="openPepText()" class="form-comment">{{ 'lemonaid-sopimus-dialog.kyc.kuka-on-pep' | translate | async }}</div>
            <button mat-icon-button (click)="poistaEdunsaaja(i); $event.preventDefault()">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        }
        <button class="primarybutton kyc-lisaa" mat-button (click)="lisaaEdunsaaja(); $event.preventDefault()">
          <!-- {{'yleiset.jatka' | translate | async }} -->
          {{ 'lemonaid-sopimus-dialog.kyc.lisaa-edunsaaja' | translate | async }}
        </button>
      </div>
      <div class="dynamic-spacer"></div>
      <div class="dynamic-spacer"></div>

      <div>
        <!-- {{'lemonaid-sopimus-dialog.lahetamme-valtakirjan-spostitse' | translate | async }} -->
        {{ 'lemonaid-sopimus-dialog.kyc.edunsaajalla-tarkoitetaan' | translate | async }}
      </div>
      <div class="dynamic-spacer"></div>
      <div class="dynamic-spacer"></div>

      <div style="font-weight: bold">{{ 'lemonaid-sopimus-dialog.kyc.miksi-tietoja-kerataan' | translate | async }}</div>
      <div class="dynamic-spacer"></div>

      <div>
        <!-- {{'lemonaid-sopimus-dialog.lahetamme-valtakirjan-spostitse' | translate | async }} -->
        {{ 'lemonaid-sopimus-dialog.kyc.naita-tuntemistietoja' | translate | async }}
      </div>
      <div>
        {{ 'lemonaid-sopimus-dialog.kyc.jos-muutoksia' | translate | async }}
      </div>
    </form>
  </div>
  <div class="dynamic-spacer"></div>
  <div class="dynamic-spacer"></div>

  @if (commonError()) {
    <div class="lemon-error">{{ commonError() }}</div>
  }
  <div class="dynamic-spacer"></div>

  <div class="button-container">
    <button class="secondarybutton" mat-button (click)="postpone()">{{ 'yleiset.myohemmin' | translate | async }}</button>
    <button class="primarybutton" mat-button (click)="tallennaKyc()">{{ 'yleiset.tallenna' | translate | async }}</button>
  </div>
  <div class="dynamic-spacer"></div>
</div>
